import React, {useState} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores";
import type {AuditLogEntry} from "../ApiTypes";
import {AuditActionLabel, SitAuditModelLabel, SitRole} from "../ApiTypes";
import {AuditLogDetailModal} from "./AuditLogDetailModal";

export const AuditLogTable: React.FC<{entries: AuditLogEntry[] | undefined}> = observer(({entries}) => {
    const {authStore} = useStores();
    const [selected, setSelected] = useState<AuditLogEntry | null>(null);
    // Row detail (before/after values) is ADMIN-only — see sit_audit.views.SitAuditLogVS.retrieve.
    const canViewDetail = authStore.sitUserProfile?.role === SitRole.ADMIN;

    if (entries !== undefined && entries.length === 0)
        return <div className="sit-muted">No activity recorded yet.</div>;

    if (!entries || entries.length === 0) return null;

    return (
        <>
            <div className="sit-table-wrap">
                <table className="sit-table">
                    <thead>
                        <tr><th>When</th><th>Who</th><th>Action</th><th>What</th></tr>
                    </thead>
                    <tbody>
                        {entries.map((entry) => (
                            <tr key={entry.id}
                                className={canViewDetail ? 'sit-row-clickable' : undefined}
                                onClick={canViewDetail ? () => setSelected(entry) : undefined}>
                                <td>{new Date(entry.created_at).toLocaleString()}</td>
                                <td>{entry.actor?.name ?? 'System'}</td>
                                <td>{AuditActionLabel[entry.action]}</td>
                                <td>
                                    {SitAuditModelLabel[entry.target_model]}
                                    {typeof entry.metadata?.field === 'string' ? ` (${entry.metadata.field})` : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <AuditLogDetailModal entry={selected} onClose={() => setSelected(null)}/>
        </>
    );
});
